import Vue from 'vue'
import Router from 'vue-router'
import Landing from '../components/Landing.vue'
import Login from '../components/Login.vue'
import Main from '../components/Main.vue'
import Dashboard from '../components/dashboard/Dashboard.vue'
import Intro from '../components/intro/Intro.vue'
import Facility from '../components/intro/Facility.vue'
import Location from '../components/intro/Location.vue'
import Program from '../components/program/Program.vue'
import ProgramList from '../components/program/List.vue'
import ProgramForm from '../components/program/Form.vue'
import ProgramView from '../components/program/View.vue'
import Job from '../components/job/Job.vue'
import JobList from '../components/job/List.vue'
import JobForm from '../components/job/Form.vue'
import JobView from '../components/job/View.vue'
import Notice from '../components/notice/Notice.vue'
import NoticeList from '../components/notice/List.vue'
import NoticeForm from '../components/notice/Form.vue'
import NoticeView from '../components/notice/View.vue'
import BoardData from '../components/boardData/BoardData.vue'
import BoardDataList from '../components/boardData/List.vue'
import BoardDataForm from '../components/boardData/Form.vue'
import BoardDataView from '../components/boardData/View.vue'
import FAQ from '../components/faq/FAQ.vue'
import Participation from '../components/participation/Participation.vue'
import Club from '../components/participation/Club.vue'
import Nest from '../components/participation/Nest.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // TODO: Only Production
  routes: [
    {
      path: '',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/Dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/Intro',
          name: 'Intro',
          component: Intro
        },
        {
          path: '/Facility',
          name: 'Facility',
          component: Facility
        },
        {
          path: '/Location',
          name: 'Location',
          component: Location
        },
        {
          path: '/Program',
          name: 'Program',
          component: Program,
          children: [
            {
              path: 'List',
              name: 'ProgramList',
              component: ProgramList
            },
            {
              path: 'Form',
              name: 'ProgramForm',
              component: ProgramForm
            },
            {
              path: 'View',
              name: 'ProgramView',
              component: ProgramView
            }
          ]
        },
        {
          path: '/Job',
          name: 'Job',
          component: Job,
          children: [
            {
              path: 'List',
              name: 'JobList',
              component: JobList
            },
            {
              path: 'Form',
              name: 'JobForm',
              component: JobForm
            },
            {
              path: 'View',
              name: 'JobView',
              component: JobView
            }
          ]
        },
        {
          path: '/Notice',
          name: 'Notice',
          component: Notice,
          children: [
            {
              path: 'List',
              name: 'NoticeList',
              component: NoticeList
            },
            {
              path: 'Form',
              name: 'NoticeForm',
              component: NoticeForm
            },
            {
              path: 'View',
              name: 'NoticeView',
              component: NoticeView
            }
          ]
        },
        {
          path: '/BoardData',
          name: 'BoardData',
          component: BoardData,
          children: [
            {
              path: 'List',
              name: 'BoardDataList',
              component: BoardDataList
            },
            {
              path: 'Form',
              name: 'BoardDataForm',
              component: BoardDataForm
            },
            {
              path: 'View',
              name: 'BoardDataView',
              component: BoardDataView
            }
          ]
        },
        {
          path: '/FAQ',
          name: 'FAQ',
          component: FAQ
        },
        {
          path: '/Participation',
          name: 'Participation',
          component: Participation,
          children: [
            {
              path: 'Club',
              name: 'Club',
              component: Club
            },
            {
              path: 'Nest',
              name: 'Nest',
              component: Nest
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js